(function ($) {
  Drupal.behaviors.aaaPartialV1 = {
    attach: function (context, settings) {
    // alert( $('.aaa-partial-v1').length );
    }
  };
})(jQuery);
